import { useTranslation } from 'react-i18next';

/**
 * Understated provenance label — makes clear where every number came from.
 * Never colour-only: the text label always carries the meaning.
 */
const STYLES = {
  USER_PROVIDED: 'text-[#527F19] border-[#527F19]/35 bg-[#F1F8E8]',
  ISO_DERIVED: 'text-[#2867B2] border-[#2867B2]/35 bg-[#2867B2]/[0.06]',
  DEFAULT_ASSUMPTION: 'text-[#B7791F] border-[#B7791F]/35 bg-[#B7791F]/[0.06]',
  MODELLED: 'text-[#66707A] border-[#DDE1E5] bg-[#F5F6F7]',
  ESTIMATED: 'text-[#66707A] border-[#DDE1E5] bg-[#F5F6F7]',
  NOT_VERIFIED: 'text-[#B42318] border-[#B42318]/35 bg-[#B42318]/[0.06]',
};

const LABEL_KEYS = {
  USER_PROVIDED: 'trust.provenanceUserProvided',
  MODELLED: 'trust.provenanceModelled',
  DEFAULT_ASSUMPTION: 'trust.provenanceDefaultAssumption',
  ISO_DERIVED: 'trust.provenanceIsoDerived',
  ESTIMATED: 'trust.provenanceEstimated',
  NOT_VERIFIED: 'trust.provenanceNotVerified',
};

export function ProvenanceBadge({ provenance = 'MODELLED', className = '' }) {
  const { t } = useTranslation();
  const style = STYLES[provenance] || STYLES.MODELLED;
  const label = t(LABEL_KEYS[provenance] || LABEL_KEYS.MODELLED);

  return (
    <span
      className={`provenance-badge inline-flex items-center border px-1.5 py-0.5 rounded-sm text-[11px] font-medium uppercase ${style} ${className}`}
      style={{ fontFamily: 'IBM Plex Mono, monospace' }}
      data-testid={`provenance-${provenance.toLowerCase().replace(/_/g, '-')}`}
    >
      {label}
    </span>
  );
}
